import { Card } from "semantic-ui-react";
import { NewPageComponent } from "../components/page/NewPageComponent";
import {
  CREATE_NEW_ELEMENT,
  CREATE_REFERENCE_LIBRARY_ELEMENT,
  NEW_DELETE_ELEMENT,
  NEW_UPDATE_ELEMENT,
} from "../routes/mutations";
import { appendIdToFormFields, getEventMetadata, getSession } from "../helper";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import { NewListPageComponent } from "../components/page/NewListPageComponent";
import { NEW_LIST_ELEMENTS } from "../routes/queries";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";
import { getNewInputElementFormFields } from "./input_element_form";
import { getSomedayMaybeFormFields } from "../somedaymaybe/someday_maybe_form";
import { ProcessInputModal } from "./ProcessInTrayElement";
import { SecondaryNavigationTabMenuComponent } from "../components/navigation_tab/SecondaryNavigationTabMenuComponent";
import { getNewNextActionFormFields } from "../nextaction/next_action_form";
import { SettingsCache } from "../cache/SettingsCache";
import { getProjectFormFields } from "../projects/project_form";
import { getNewWaitingForFormFields } from "../waitingfor/waiting_for_form";
import {
  getReferenceLibraryForm,
  getReferenceLibraryFormFields,
} from "../referencelibrary/reference_library_form";

export const CreateInputElementForm = () => {
  const onSuccess = (data: any) => {
    form.resetForm();
  };

  const form = new NewNewFormComponentProps({
    form: {
      formFields: getNewInputElementFormFields("Create Input"),
      type: "single_form",
    },
    startingData: { name: "" },
  });

  return (
    <NewPageComponent
      props={{
        type: "form",
        form: form,
        button: {
          label: "Submit",
          apiCall: CREATE_NEW_ELEMENT,
          callback: onSuccess,
        },
      }}
    />
  );
};

const InputElementCard = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <Card.Header style={{ fontSize: 18 }}>
            <b>{props.data.name}</b>
          </Card.Header>
          <CardDotMenuComponent
            cardData={props.data}
            props={{
              menuItems: [
                {
                  type: "api_call",
                  label: "Delete",
                  apiCall: NEW_DELETE_ELEMENT,
                  callback: (
                    data: any,
                    setReloadKey: any,
                    pageData: any,
                    setPageData: any,
                  ) => {
                    setReloadKey((k: number) => k + 1);
                  },
                  apiCallVariables: (data: any) => {
                    return {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                      isChildElement: true,
                    };
                  },
                  showMenuOption: (data: any) => {
                    return true;
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: NEW_UPDATE_ELEMENT,
                  label: "Edit",
                  modalHeader: "Edit Input",
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getNewInputElementFormFields("Name"),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: NEW_UPDATE_ELEMENT,
                  label: "Change To Someday/Maybe",
                  modalHeader: "Change To Someday/Maybe",
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getSomedayMaybeFormFields(),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: NEW_UPDATE_ELEMENT,
                  label: "Change To Next Action",
                  modalHeader: "Change To Next Action",
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getNewNextActionFormFields(),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                      priority:
                        SettingsCache.getInstance().getDefaultPriority(),
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: NEW_UPDATE_ELEMENT,
                  label: "Change To Project",
                  modalHeader: "Change To Project",
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getProjectFormFields(),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: NEW_UPDATE_ELEMENT,
                  label: "Change To Waiting For",
                  modalHeader: "Change To Waiting For",
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getNewWaitingForFormFields(),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: {
                    documentNode: CREATE_REFERENCE_LIBRARY_ELEMENT,
                    key: "createReferenceLibraryElement",
                  },
                  label: "Change To Reference Library",
                  modalHeader: "Change To Reference Library",
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: getReferenceLibraryForm(),
                    startingData: {
                      name: props.data.name,
                      type: 1,
                      inputElementId: props.data.id,
                      elementIds: [],
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
              ],
            }}
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
          />
        </div>
      </Card.Content>
      <Card.Content>
        <ProcessInputModal
          input={props.data}
          deleteCallback={(id: number) => {
            props.setReloadKey((k: number) => k + 1);
          }}
        />
      </Card.Content>
    </Card>
  );
};

export const NewProcessInputPage = () => {
  return (
    <NewListPageComponent
      props={{
        type: "list_page",
        query: NEW_LIST_ELEMENTS,
        queryVariables: {
          session: getSession(),
          types: [1],
          appendTypeToName: false,
        },
        itemName: "Input",
        card: InputElementCard,
      }}
    />
  );
};

export const NewInputPage = () => {
  return (
    <SecondaryNavigationTabMenuComponent
      props={{
        menuItems: [
          {
            name: "Create Input",
            tooltip: "Create a new input to track something",
            pageComponent: {
              type: "hardcoded_page",
              page: <CreateInputElementForm />,
            },
          },
          {
            name: "Process Input",
            tooltip: "Process inputs and assign them to the right categories",
            pageComponent: {
              type: "list_page",
              query: NEW_LIST_ELEMENTS,
              queryVariables: {
                session: getSession(),
                types: [1],
                appendTypeToName: false,
              },
              itemName: "Input",
              card: InputElementCard,
            },
          },
        ],
      }}
    />
  );
};
